import { useEffect, useEffectEvent, useRef, useState } from 'react';

import { InputAdornment } from '@/shared/ui';
import { Search } from '@/shared/ui/icons';

import { useFilter } from '../../../state/useFilter';

import PostHogTextField from './PostHogSearch';

const SEARCH_DEBOUNCE_DELAY = 700;

const TableSearch = ({ tabId }: { tabId: string }) => {
  const { filters, setFilter } = useFilter();

  const inputRef = useRef<HTMLInputElement>(undefined);

  const [value, setValue] = useState(filters.search ?? '');
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    if (value) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setFilter('search', value);
      }, SEARCH_DEBOUNCE_DELAY);
    } else if (filters.search !== null) {
      setFilter('search', null);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [filters.search, setFilter, value]);

  const resetSearch = useEffectEvent(() => {
    setValue('');
  });

  useEffect(() => {
    // oxlint-disable-next-line react-hooks-js/set-state-in-effect -- Reflect external URL/filter resets in the controlled input.
    if (!filters.search) resetSearch();
  }, [filters.search]);

  return (
    <PostHogTextField
      hiddenLabel
      id={tabId}
      inputRef={inputRef}
      placeholder='Search codes, titles, hubs...'
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment
              position='start'
              sx={{ m: 0 }}
              onClick={() => {
                if (inputRef.current) inputRef.current.focus();
              }}
            >
              <Search
                color='info'
                sx={{ fontSize: 20 }}
              />
            </InputAdornment>
          )
        }
      }}
      sx={{
        minWidth: 301,
        '& .MuiFilledInput-root': {
          backgroundColor: 'transparent',
          border: '1px solid',
          borderColor: 'gx.text',
          height: 32,
          '& .MuiInputBase-input': {
            py: 0,
            px: 1,
            fontSize: '14px'
          }
        }
      }}
      value={value}
      variant='filled'
      onChange={e => {
        setValue(e.target.value);
      }}
    />
  );
};

export default TableSearch;
